import { AlignmentType, Paragraph, TextRun } from "docx"

export const applicationThreatModeling = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 500, after: 200 },
    children: [
        new TextRun({
            text: "Application Threat Modelling",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const applicationThreatModelingText = new Paragraph({
    alignment: AlignmentType.JUSTIFIED,
    spacing: { before: 100, after: 200 },
    // spacing: { line: 376 },
    children: [
        new TextRun({
            text: "During this phase We consultants would closely review the Internet point of presence of infrastructure to get a better understanding and finalize application assessment objectives. Below listed activities would be carried out during the threat modelling phase.",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})

export const overview = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 100, after: 300 },

    children: [
        new TextRun({
            text: "Get application overview (Business and Technical)",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})


export const applicationBulletOne = new Paragraph({
    indent: { left: 800, },
    alignment: AlignmentType.JUSTIFIED,
    spacing: { line: 276, before: 150, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Understand and note systems functionality / component segregation",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const applicationBulletTwo = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, before: 150, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Interfacing layers and protocols",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const applicationBulletThree = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, before: 150, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Deployment and configurations requirements. ",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})


export const applicationBulletFour = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, before: 150, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Identification of technical components supporting the application and its associated interfaces",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})


export const applicationBulletFive = new Paragraph({
    indent: { left: 800, },
    spacing: { line: 276, before: 150, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Information gathered above would be analyzed to identify threats and associated vulnerabilities within system components and its interfaces",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const applicationBulletSix = new Paragraph({
    indent: { left: 800, },

    spacing: { line: 276, before: 150, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identification of security test cases",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const SourceCodeReview = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 500, after: 200 },
    children: [
        new TextRun({
            text: "Source Code Review",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const sourceCodeText1 = new Paragraph({
    alignment: AlignmentType.JUSTIFIED,
    spacing: { before: 250, after: 200, line: 376 },

    children: [
        new TextRun({
            text: "Source code review process involves both manual and automated code review. In the automated review process, most of the tools capture the static security issues in the code and produce good amount of low critical findings and warning. Automated tool also helps in capturing developer’s comments inside the code where sometime sensitive information is hard coded.",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})
export const sourceCodeText2 = new Paragraph({
    alignment: AlignmentType.JUSTIFIED,
    spacing: { before: 200, after: 200, line: 376 },

    children: [
        new TextRun({
            text: "Critical code segments identified during the review planning phase goes through rigorous manual review process. code review checklist and the application threat profile document form the basis for conducting the manual review process. Team verifies the findings reported by the tools prioritized them based on their criticality and impact.  ",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})